"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var router_1 = require("@angular/router");
var Observable_1 = require("rxjs/Observable");
var common_1 = require("@angular/common");
var ReplaySubject_1 = require("rxjs/ReplaySubject");
var idm_dynamic_layout_interpreter_1 = require("@synisys/idm-dynamic-layout-interpreter");
var operators_1 = require("rxjs/operators");
var Subject_1 = require("rxjs/Subject");
var pipe_1 = require("rxjs/util/pipe");
var dynamic_navigation_helper_1 = require("../../common/utils/dynamic-navigation-helper");
var root_category_summary_page_config_service_1 = require("../../../../shared/services/api/summary-pages/root-category-summary-page-config-service");
var summary_page_configs_helper_service_1 = require("../../common/service/summary-page-configs-helper.service");
/**
 * Component for configuring summary page of selected root category.
 */
var SummaryPagesConfigPageComponent = /** @class */ (function () {
    function SummaryPagesConfigPageComponent(rootCategorySummaryPageConfigService, summaryPageConfigsHelperService, location, route) {
        this.rootCategorySummaryPageConfigService = rootCategorySummaryPageConfigService;
        this.summaryPageConfigsHelperService = summaryPageConfigsHelperService;
        this.location = location;
        this.route = route;
        this.isValidCategory = true;
        this.isValidName = true;
        this.destroy$ = new ReplaySubject_1.ReplaySubject(1);
        this.saveCancelAction = new Subject_1.Subject();
    }
    SummaryPagesConfigPageComponent.prototype.ngOnInit = function () {
        this.rootCategory = dynamic_navigation_helper_1.getPropertyFromUrl('rootCategory', this.route);
        this.config$ = this.rootCategorySummaryPageConfigService.getConfigByRootCategory(this.rootCategory).pipe(operators_1.map(function (config) {
            return config.clone();
        }), operators_1.shareReplay(1));
        this.viewFormsList$ = this.summaryPageConfigsHelperService.getFormsOfCategory(this.rootCategory, idm_dynamic_layout_interpreter_1.FormType.VIEW)
            .pipe(operators_1.shareReplay(1));
        this.subscribeToSaveCancelActions();
    };
    SummaryPagesConfigPageComponent.prototype.subscribeToSaveCancelActions = function () {
        var _this = this;
        this.saveCancelAction.pipe(operators_1.switchMap(function (isSave) {
            if (isSave) {
                return _this.config$.pipe(operators_1.switchMap(function (config) {
                    _this.isValidCategory = !!config.category;
                    _this.isValidName = !!config.formId;
                    if (_this.isValidCategory && _this.isValidName) {
                        return _this.rootCategorySummaryPageConfigService.save(config)
                            .pipe(operators_1.map(function () {
                            _this.location.back();
                            return true;
                        }));
                    }
                    return Observable_1.Observable.of(false);
                }));
            }
            else {
                _this.location.back();
                return Observable_1.Observable.of(false);
            }
        }), pipe_1.pipe(operators_1.takeUntil(this.destroy$))).subscribe();
    };
    SummaryPagesConfigPageComponent.prototype.onAction = function (isSave) {
        this.saveCancelAction.next(isSave);
    };
    SummaryPagesConfigPageComponent.prototype.ngOnDestroy = function () {
        this.destroy$.next(true);
        this.destroy$.complete();
    };
    SummaryPagesConfigPageComponent = __decorate([
        core_1.Component({
            selector: "ejustice-summary-pages-config-page",
            styles: [require('./summary-pages-config-page.component.css')],
            template: require('./summary-pages-config-page.component.html'),
        }),
        __metadata("design:paramtypes", [root_category_summary_page_config_service_1.RootCategorySummaryPageConfigService,
            summary_page_configs_helper_service_1.SummaryPageConfigsHelperService,
            common_1.Location,
            router_1.ActivatedRoute])
    ], SummaryPagesConfigPageComponent);
    return SummaryPagesConfigPageComponent;
}());
exports.SummaryPagesConfigPageComponent = SummaryPagesConfigPageComponent;
//# sourceMappingURL=summary-pages-config-page.component.js.map